import _ from "lodash";
import {
  BarChartType,
  PieChartDataType,
  PieDonutChartDataType,
  SelectDataType,
} from "../../types/charts";

export const geojsonToPie = (geojson: GeoJSON.FeatureCollection) => {
  const data: PieChartDataType = [];
  const flatData = geojson.features.map((feature) => feature.properties);
  const aggregatedMaterials = _.groupBy(flatData, (props) => {
    if (!props.master_material) {
      //some items aren't linked to a master material.
      // just set them to other
      if (!props.material_name) {
        if (!props.material) {
          return "OTHER ITEMS";
        }
        return props.material;
      }
      return props.material_name;
    }
    return props.master_material;
  });

  Object.keys(aggregatedMaterials).map((key) => {
    // if (key === "PLASTIC") {
    data.push({ name: key, y: aggregatedMaterials[key].length });
    // }
  });

  return data;
};

export const geojsonToBar = (geojson: GeoJSON.FeatureCollection) => {
  const data: BarChartType = [];

  const flatData = geojson.features.map((feature) => feature.properties);

  const aggregatedItemNames = _.groupBy(flatData, (props) => {
    return props.itemname;
  });

  Object.keys(aggregatedItemNames).map((key) => {
    data.push({
      name: key,
      data: aggregatedItemNames[key].reduce(
        (prev, curr) => prev + parseInt(curr.quantity, 10),
        0
      ),
    });
  });

  data.sort((a, b) => {
    return b.data - a.data;
  });

  return data.slice(0, 5);
};

export const geojsonToDegradedMaterialBar = (
  geojson: GeoJSON.FeatureCollection,
  material: String
) => {
  const flatData = geojson.features.map((feature) => feature.properties);
  console.log({ material });
  const aggregatedMaterials: any[] = [];
  geojson.features.forEach((data) => {
    let material_name;

    if (!data["material_name"]) {
      //some items aren't linked to a master material.
      // just set them to other
      if (!data["material"]) {
        return "OTHER ITEMS";
      }
      material_name = data["material"];
    } else {
      material_name = data["material_name"];
    }

    console.log({ material_name });

    // console.log({ material_name });
    if (material_name === material) {
      console.log({ material_name });
      aggregatedMaterials.push(data);
    }
  });

  console.log("aggr", aggregatedMaterials);

  const counts = {
    degraded: aggregatedMaterials.filter((item) => item.degraded === 1).length,
    other: aggregatedMaterials.filter((item) => item.degraded !== 1).length,
  };
  console.log("other", counts.other);

  return { total: aggregatedMaterials.length, degraded: counts.degraded };
};

export const geojsonToDegradedBar = (geojson: GeoJSON.FeatureCollection) => {
  const flatData = geojson.features.map((feature) => feature.properties);

  const degradedCount = flatData.filter((item) => item.degraded === 1).length;

  console.log("de", flatData.length);

  return { total: flatData.length, degraded: degradedCount };
};

export const geojsonToBarETAP = (geojson: GeoJSON.FeatureCollection) => {
  const data: BarChartType = [];

  const flatData = geojson.features.map((feature) => feature.properties);

  const aggregatedItemNames = _.groupBy(flatData, (props) => {
    return props.etap_2_name;
  });

  Object.keys(aggregatedItemNames).map((key) => {
    data.push({
      name: key,
      data: aggregatedItemNames[key].reduce(
        (prev, curr) => prev + parseInt(curr.quantity, 10),
        0
      ),
    });
  });

  data.sort((a, b) => {
    return b.data - a.data;
  });

  return data.slice(0, 5);
};

export const geojsonToMaterialPie = (
  geojson: GeoJSON.FeatureCollection,
  material: String
) => {
  const data: PieChartDataType = [];
  const flatData = geojson.features.map((feature) => feature.properties);
  const aggregatedMaterials = _.groupBy(flatData, (props) => {
    let material_name;

    if (!props.material_name) {
      //some items aren't linked to a master material.
      // just set them to other
      if (!props.material) {
        return "OTHER ITEMS";
      }
      material_name = props.material;
    } else {
      material_name = props.material_name;
    }

    if (material_name === material) {
      return props.etap_2_name;
    }
  });

  Object.keys(aggregatedMaterials).map((key) => {
    if (key !== "undefined") {
      data.push({ name: key, y: aggregatedMaterials[key].length });
    }
  });

  return data;
};

export const geojsonToMaterialBarETAP = (
  geojson: GeoJSON.FeatureCollection,
  material: String
) => {
  const data: BarChartType = [];
  const flatData = geojson.features.map((feature) => feature.properties);
  const aggregatedMaterials = _.groupBy(flatData, (props) => {
    let material_name;

    if (!props.material_name) {
      //some items aren't linked to a master material.
      // just set them to other
      if (!props.material) {
        return "OTHER ITEMS";
      }
      material_name = props.material;
    } else {
      material_name = props.material_name;
    }

    if (material_name === material) {
      return props.etap_2_name;
    }
  });

  Object.keys(aggregatedMaterials).map((key) => {
    if (key !== "undefined") {
      data.push({
        name: key,
        data: aggregatedMaterials[key].reduce(
          (prev, curr) => prev + parseInt(curr.quantity, 10),
          0
        ),
        parent_index: aggregatedMaterials[key][0].etap_1_index
          ? aggregatedMaterials[key][0].etap_1_index
          : aggregatedMaterials[key][0].material_index,
      });
    }
  });

  data.sort((a, b) => {
    return b.data - a.data;
  });

  return data.slice(0, 10);
};

export const geojsonToSelect = (geojson: GeoJSON.FeatureCollection) => {
  const data: SelectDataType = [];
  const flatData = geojson.features.map((feature) => feature.properties);

  const aggregatedMaterials = _.groupBy(flatData, (props) => {
    if (!props.material_name) {
      //some items aren't linked to a master material.
      // just set them to other
      if (!props.material) {
        return "OTHER ITEMS";
      }
      return props.material;
    } else {
      return props.material_name;
    }
  });

  Object.keys(aggregatedMaterials).map((key) => {
    // if (key === "PLASTIC") {
    data.push({ label: key, value: key });
    // }
  });

  return data;
};

const computePieDonutData2 = (
  etap1,
  etap1Counts,
  etap2,
  etap2Counts,
  etap1Names
) => {
  // console.log("etap1", etap1);
  // console.log("etap1Counts", etap1Counts);
  // console.log("etap2", etap2);
  // console.log("etap2Counts", etap2Counts);
  // console.log("etap1Names", etap1Names);

  etap2.sort((a, b) => a.etapTwo.localeCompare(b.etapTwo));
  etap2.sort((a, b) => a.etapOne - b.etapOne);
  // console.log("etap2sorted", etap2);

  let parent = 0;
  let children = [];
  let childrenData = [];
  let finishedData: PieDonutChartDataType[] = [];
  let checkChildren = [];
  let checkChildrenData = []; // tracks which items have been placed in childrenData

  let data: PieDonutChartDataType = {
    y: undefined,
    color: undefined,
    drilldown: {
      name: undefined,
      categories: [],
      data: [],
      color: undefined,
    },
  };

  for (let i = 0; i < etap2.length; i++) {
    if (parent < etap2[i].etapOne) {
      parent = etap2[i].etapOne;
    }
    // console.log("try,", etap1Names[etap2[i].etapOne]);
    // check to ensure no duplicates
    if (!checkChildren.includes(etap2[i].etapTwo)) {
      children.push(etap2[i].etapTwo);
      checkChildren.push(etap2[i].etapTwo);
    }

    // if index not last index
    if (i != etap2.length - 1) {
      // if next index is not the same item, check already includes etapTwo
      if (
        etap2[i].etapTwo != etap2[i + 1].etapTwo &&
        !checkChildrenData.includes(etap2[i].etapTwo)
      ) {
        childrenData.push(etap2Counts[etap2[i].etapTwo]);
        checkChildrenData.push(etap2[i].etapTwo);
      }

      if (parent != etap2[i + 1].etapOne) {
        // if next item isn't apart of parent group
        data.y = etap1Counts[parent];
        data.drilldown.name = etap1Names[etap2[i].etapOne];
        data.drilldown.categories = children;

        if (childrenData.length != children.length) {
          childrenData.push(etap2Counts[etap2[i].etapTwo]);
        }

        data.drilldown.data = childrenData;
        finishedData.push(data);

        // reset for the next parent group
        children = [];
        childrenData = [];
        checkChildren = [];
        checkChildrenData = [];
        data = {
          y: undefined,
          color: undefined,
          drilldown: {
            name: undefined,
            categories: [],
            data: [],
            color: undefined,
          },
        };
      }
    } else {
      data.y = etap1Counts[parent];
      data.drilldown.name = etap1Names[etap2[i].etapOne];
      data.drilldown.categories = children;

      if (childrenData.length != children.length) {
        childrenData.push(etap2Counts[etap2[i].etapTwo]);
      }

      data.drilldown.data = childrenData;
      finishedData.push(data);
    }
  }

  console.log("finishedData", finishedData);
  return finishedData;
};

const computePieDonutData = (flatData, material) => {
  let etap1 = [];
  let etap2 = [];
  let etap1Counts = {};
  let etap2Counts = {};
  let etap1Names = {};

  let trimmedData = [];

  flatData.forEach((item) => {
    if (item.material === material) {
      trimmedData.push(item);
    }
  });

  trimmedData.forEach((item) => {
    let parent_index;
    let parent_name;
    if (item.etap_1_index) {
      parent_index = item.etap_1_index;
      parent_name = item.etap_1_name;
    } else {
      parent_index = item.material_index;
      parent_name = item.material;
    }

    etap1Counts[parent_index] = (etap1Counts[parent_index] || 0) + 1;
    etap1Names[parent_index] = parent_name;

    etap2.push({ etapTwo: item.etap_2_name, etapOne: parent_index });
    etap2Counts[item.etap_2_name] = (etap2Counts[item.etap_2_name] || 0) + 1;
  });

  const finishedData = computePieDonutData2(
    etap1,
    etap1Counts,
    etap2,
    etap2Counts,
    etap1Names
  );

  return finishedData;
};

export const geojsonToPieDonut = (
  geojson: GeoJSON.FeatureCollection,
  material: String
) => {
  const flatData = geojson.features.map((feature) => feature.properties);

  const finishedData = computePieDonutData(flatData, material);

  return finishedData;
};
